
import type { ISuggestItem, ISuggestItemServer } from '../types';
export const MaterialApi = Symbol('MaterialApi');

export interface MaterialApi {
    suggestPlaybook(keyword: string, fields?: string, playbook?: string): Promise<ISuggestItem[]>;

    suggestField(keyword: string, field: string, n?: number): Promise<ISuggestItemServer[]>;

    /**
     * 获取推荐词
     */
    recommends(): Promise<{[key in string] :IQueryRoot[]}>;
}
